import { InjectionToken } from "@angular/core";
import type { TabServiceTab } from "src/app/services/tab.service";

export type PageDatagridTabShellContext = {
  tab: TabServiceTab | undefined;
};

export const PAGE_DATAGRID_TAB_SHELL =
  new InjectionToken<PageDatagridTabShellContext>("page_datagrid_tab_shell");
